import { render, staticRenderFns } from "./ReturnPartsDetail.vue?vue&type=template&id=2662f070"
import script from "./ReturnPartsDetail.vue?vue&type=script&lang=js"
export * from "./ReturnPartsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports